import React, { useEffect, useState } from 'react'
import Topbar from '../layout/Topbar'
import { useNavigate } from 'react-router-dom'
import api from '../../api/axios';
import { useBookStore } from '../../provider/BookStore';
import { useMasterStore } from '../../provider/MasterStore';
import Navbar from '../layout/Navbar';

const Pocket = () => {
    const bookState = useBookStore();
    const book = bookState.book;

    const navigate = useNavigate();

    // cache master data — halaman ini sumber kebenaran saat add/edit/delete
    const masterStore = useMasterStore();

    const [pockets, setPockets] = useState([]);
    const [modalAdd, setModalAdd] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [title, setTitle] = useState('')
    const [pocketId, setPocketId] = useState(null);
    const [isLoading,setLoading] = useState(false)

    useEffect(() => {
        if (book.id === undefined) {
            navigate('/')
        }

        getPockets();
    }, []);

    const getPockets = async () => {
        // halaman manajemen: selalu ambil data terbaru (force),
        // sekaligus meng-update cache untuk halaman lain
        setLoading(true)
        const poc = await masterStore.loadPockets(book.id, { force: true });
        if (poc) {
            setPockets(poc)
        }
        setLoading(false)
    }

    const handleAdd = async() => {
        try {
            await api.post('/pocket/add',{
                title: title,
                book_id: book.id
            }).then(res=>{
                console.log(res.data)
                setModalAdd(!modalAdd)
                getPockets()
            })
        } catch (error) {
            // buang cache supaya form di halaman lain tidak pakai data lama
            masterStore.invalidatePockets(book.id);
            console.error('Gagal menambah dompet:', error?.response || error?.message);
        }
    }

    const handleEdit = async() => {
        try {
            await api.post('/pocket/save',{
                title:title,
                pocket_id:pocketId
            }).then(res=>{
                setModalEdit(!modalEdit)
                getPockets()
            })
        } catch (error) {
            masterStore.invalidatePockets(book.id);
            console.error('Gagal menyimpan dompet:', error?.response || error?.message);
        }
    }

    const handleDelete = async() => {
        try {
            await api.post('/pocket/delete',{
                pocket_id:pocketId
            }).then(res=>{
                setModalEdit(!modalEdit)
                getPockets()
            })
        } catch (error) {
            masterStore.invalidatePockets(book.id);
            console.error('Gagal menghapus dompet:', error?.response || error?.message);
        }
    }

    const handleTap = (pocket)=>{
        setTitle(pocket.title)
        setPocketId(pocket.id)
        setModalEdit(!modalEdit)
    }

    return (
        <div>
            <Topbar
                title={'Dompet'}
                back={() => navigate(-1)}
                isLoading={isLoading}
            />
            <div className='container p-5'>

                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                        <div className='card'>
                            <header className='card-header'>
                                <p className='card-header-title'>Daftar Dompet</p>
                                <button className="card-header-icon" onClick={() => { setModalAdd(!modalAdd);setTitle('') }}>
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </header>
                            <div className='card-content'>
                                {pockets.map((pocket, index) => (
                                    <div key={index} className='is-clickable mb-2'>
                                        <div className='is-clearfix' onClick={()=>{handleTap(pocket)}}>
                                            <div className='is-pulled-left' >
                                                <p className='is-size-6'> {pocket.title}</p>
                                            </div>

                                            <div className='is-pulled-right'>
                                                {/* <span className="icon ">
                                                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                                </span> */}
                                            </div>

                                        </div>
                                        <hr className='mt-3 mb-3' />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* modal edit pocket */}
                <div className={`modal p-5 ${(modalEdit) ? 'is-active' : ''}`}>
                    <div className="modal-background"></div>
                    <div className="modal-content card">
                        <header className='card-header'>
                            <p className="card-header-title">Edit Dompet</p>
                            <button className="card-header-icon" onClick={() => { setModalEdit(!modalEdit) }}>
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </header>
                        <div className='card-content'>
                            <div className="field">
                                <label className="label">Nama Dompet</label>
                                <div className="controls">
                                    <input type="text" className="input" placeholder=''
                                        value={title} onChange={(e) => setTitle(e.target.value)} />
                                </div>
                            </div>

                        </div>
                        <footer className='card-footer'>
                            <button className='card-footer-item has-text-danger'
                                onClick={()=>{ handleDelete() }}>
                                Hapus
                            </button>
                            <button className='card-footer-item'
                                onClick={()=>{ setModalEdit(!modalEdit) }}>
                                Batal
                            </button>
                            <button className='card-footer-item'
                                onClick={()=>handleEdit()}>
                                Simpan
                            </button>
                        </footer>
                    </div>

                </div>

                {/* modal add pocket */}
                <div className={`modal p-5 ${(modalAdd) ? 'is-active' : ''}`}>
                    <div className="modal-background"></div>
                    <div className="modal-content card">
                        <header className='card-header'>
                            <p className="card-header-title">Tambah Pocket</p>
                            <button className="card-header-icon" onClick={() => { setModalAdd(!modalAdd) }}>
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </header>
                        <div className='card-content'>
                            <div className="field">
                                <label className="label">Nama Dompet</label>
                                <div className="controls">
                                    <input type="text" className="input" placeholder=''
                                        value={title} onChange={(e) => setTitle(e.target.value)} />
                                </div>
                            </div>

                        </div>
                        <footer className='card-footer'>
                            <button className='card-footer-item'
                                onClick={()=>{ setModalAdd(!modalAdd) }}>
                                Batal
                            </button>
                            <button className='card-footer-item'
                                onClick={()=>handleAdd()}>
                                Simpan
                            </button>
                        </footer>
                    </div>

                </div>
            </div>
            {/* <Navbar /> */}
        </div>
    )
}

export default Pocket
